import { BasicClient } from '@/utils/httpClient'

export default class SichernConnect {
  constructor () {
    this.client = new BasicClient()
  }

  enroll (userId) {
    return this.client.exec(`/externalapis/sichern-connect/users/${userId}/enroll`, 'PUT')
  }
}
